import moment from 'moment';
import useBasketContext from '../contexts/basket/useBasketContext';
import useSiteContext from '../contexts/site/useSiteContext';
import { estimateOffer, OfferEstimate, siteNow } from '../services/offers';

/**
 * The offer the basket gets, as far as can be told before it is validated: what a customer is shown of their total while they are still ordering.
 * Nothing when a code of their own is on the basket (it takes the offer's place), or when there is nothing to take off.
 *
 * @param deliveryFee for an offer that takes a percentage of the total
 */
const useOfferEstimate = (deliveryFee = 0): OfferEstimate | null => {
    const basketContext = useBasketContext();
    const siteContext = useSiteContext();

    if (siteContext.offers.length === 0 || basketContext.basketItems.length === 0) {
        return null;
    }

    if ((basketContext.validatedBasket?.codes ?? []).some((code) => !code.offer)) {
        return null;
    }

    // (the time the order is for, when one has been chosen, as offers can be for certain days and times)
    const chosen = basketContext.timeslot ? moment(basketContext.timeslot.id, 'YYYY-MM-DD HH:mm', true) : null;
    const at = chosen && chosen.isValid() ? chosen : siteNow(siteContext.site?.timezone);

    return estimateOffer(siteContext.offers, siteContext.menu, basketContext.basketItems, deliveryFee, at);
};

export default useOfferEstimate;
